import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  Image,
  Tooltip,
} from "@chakra-ui/react";
import moment from "moment";
import { useContext } from "react";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import { LiaToolsSolid } from "react-icons/lia";
export default function IntegrationCard({
  url,
  heading,
  description,
  active,
  onClickIntegration,
  data,
  last_updatedAt,
  isUserEligableForChannel,
}) {
  const agency = useContext(AgencyContext);
  const { buttonColorScheme, myDetails, cardBg } = agency;
  const toolTipMsg =
    myDetails && myDetails?.agency_id
      ? `Please contact ${myDetails?.branding?.agency_name || ""} `
      : "Please upgrade to platinum or above";

  return (
    <Card bg={cardBg} width={"200px"}>
      <CardBody position={"relative"} overflow={"hidden"}>
        <Flex
          justifyContent={"space-between"}
          flexDir={"column"}
          alignItems={"center"}
          h={"100%"}
        >
          <Flex
            justifyContent={"space-between"}
            alignItems={"center"}
            flexDir={"column"}
            h={"100%"}
          >
            <Image
              objectFit={"contain"}
              width={100}
              h={100}
              src={url}
              fallback={
                <LiaToolsSolid
                  size={70}
                  style={{
                    margin: "auto",
                  }}
                />
              }
              alt="Bamboo"
              borderRadius="lg"
            />
            <Box marginBlock={3}>
              <Heading textAlign={"center"} size="sm">
                {heading}
              </Heading>
            </Box>
          </Flex>

          {isUserEligableForChannel && last_updatedAt ? (
            <Box textAlign={"center"}>
              Last updated at:{" "}
              {moment.utc(last_updatedAt).local().format("YYYY-MM-DD HH:mm")}
            </Box>
          ) : (
            <></>
          )}

          <Tooltip
            placement="bottom"
            label={
              !active
                ? "Coming soon"
                : !isUserEligableForChannel
                ? toolTipMsg
                : ""
            }
          >
            <Button
              size={"xs"}
              colorScheme={buttonColorScheme}
              cursor={active ? "cursor" : "auto"}
              margin={"auto"}
              isActive={!active}
              onClick={active ? onClickIntegration : undefined}
              isDisabled={!isUserEligableForChannel}
            >
              {active ? (last_updatedAt ? "Update" : "Set up") : "Coming soon"}
            </Button>
          </Tooltip>
        </Flex>
      </CardBody>
    </Card>
  );
}
